import * as ACTION_TYPES from "../actions/action-types";

const initialState = {
  automations: [],
  selectedAutomation: null,
  showSidebar: false,
  triggerToOpen: null,
};

const automation = (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPES.GET_AUTOMATIONS:
      return {
        ...state,
        automations: action.payload,
      };

    case ACTION_TYPES.ADD_AUTOMATION:
      return {
        ...state,
        automations: [...state.automations, action.payload],
      };

    case ACTION_TYPES.UPDATE_AUTOMATION:
      return {
        ...state,
        automations: state.automations.map((automation) =>
          automation.id === action.payload.id ? { ...automation, ...action.payload } : automation
        ),
        selectedAutomation:
          state.selectedAutomation?.id === action.payload.id
            ? { ...state.selectedAutomation, ...action.payload }
            : state.selectedAutomation,
      };

    case ACTION_TYPES.UPDATE_MULTIPLE_AUTOMATIONS:
      return {
        ...state,
        automations: state.automations.map((automation) => {
          const updatedAutomation = action.payload.find((updated) => updated.id === automation.id);
          return updatedAutomation ? { ...automation, ...updatedAutomation } : automation;
        }),
        selectedAutomation: (() => {
          const match = action.payload.find((updated) => updated.id === state.selectedAutomation?.id);
          return match && state.selectedAutomation ? { ...state.selectedAutomation, ...match } : state.selectedAutomation;
        })(),
      };

    case ACTION_TYPES.UPDATE_AUTOMATION_TRIGGER:
      return {
        ...state,
        automations: state.automations.map((automation) => {
          if (automation.triggers && Array.isArray(automation.triggers)) {
            const updatedTriggers = automation.triggers.map((trigger) => (trigger.TriggerId === action.payload.TriggerId ? action.payload : trigger));
            return {
              ...automation,
              triggers: updatedTriggers,
            };
          }
          return automation;
        }),
        selectedAutomation: state.selectedAutomation
          ? {
              ...state.selectedAutomation,
              triggers:
                state.selectedAutomation.triggers?.map((trigger) => (trigger.TriggerId === action.payload.TriggerId ? action.payload : trigger)) ||
                [],
            }
          : null,
      };

    case ACTION_TYPES.DELETE_AUTOMATION_TRIGGER:
      return {
        ...state,
        automations: state.automations.map((automation) => {
          if (automation.triggers && Array.isArray(automation.triggers)) {
            const updatedTriggers = automation.triggers.filter((trigger) => trigger.TriggerId !== action.payload);
            return {
              ...automation,
              triggers: updatedTriggers,
            };
          }
          return automation;
        }),
        selectedAutomation: state.selectedAutomation
          ? {
              ...state.selectedAutomation,
              triggers: state.selectedAutomation.triggers?.filter((trigger) => trigger.TriggerId !== action.payload) || [],
            }
          : null,
      };

    case ACTION_TYPES.DELETE_AUTOMATION:
      return {
        ...state,
        automations: state.automations.filter((automation) => automation.id !== action.payload),
        selectedAutomation: state.selectedAutomation?.id === action.payload ? null : state.selectedAutomation,
        showSidebar: state.selectedAutomation?.id === action.payload ? false : state.showSidebar,
      };

    case ACTION_TYPES.SET_SELECTED_AUTOMATION:
      return {
        ...state,
        selectedAutomation: action.payload,
      };

    case ACTION_TYPES.SET_AUTOMATION_SIDEBAR_VISIBLE:
      return {
        ...state,
        showSidebar: action.payload,
      };

    case ACTION_TYPES.SET_TRIGGER_TO_OPEN:
      return {
        ...state,
        triggerToOpen: action.payload,
      };

    case ACTION_TYPES.CLEAR_TRIGGER_TO_OPEN:
      return {
        ...state,
        triggerToOpen: null,
      };

    default:
      return state;
  }
};

export default automation;
